import { render, staticRenderFns } from "./RoomCardDebuggerDetailed.vue?vue&type=template&id=bf80c012&scoped=true"
import script from "./RoomCardDebuggerDetailed.vue?vue&type=script&lang=js"
export * from "./RoomCardDebuggerDetailed.vue?vue&type=script&lang=js"
import style0 from "./RoomCardDebuggerDetailed.vue?vue&type=style&index=0&id=bf80c012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf80c012",
  null
  
)

export default component.exports